// Identidade da marca. Nome, textos de marca e endereços públicos moram só aqui; o desenho do símbolo e do
// logotipo, em ./logo.ts. Manual: docs/MARCA.md.

export const marca = {
  nome: 'EntregueCerto',
  nomeCurto: 'EntregueCerto',
  apps: {
    entregador: 'EntregueCerto Entregador',
    dono: 'EntregueCerto',
  },
  /** Para que serve cada app, logo abaixo do logotipo na tela de entrada. */
  papelDosApps: {
    entregador: 'App do entregador',
    dono: 'App do dono da loja',
  },
  assinaturaRastreio: 'Entregas organizadas com',
  /** Domínios escolhidos em 18/10/2026 (livres nessa data; ainda não registrados). */
  dominio: 'entreguecerto.com.br',
  suporte: {
    /** O mesmo da página inicial e dos e-mails do login. */
    email: 'contato@entreguecerto.com.br' as string | null,
    /** WhatsApp do Matheus (só dígitos, com DDI): "Falar com a gente", dúvidas e rodapé da página inicial. */
    whatsapp: '5583987437455' as string | null,
  },
} as const;

export type Marca = typeof marca;
